import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Play extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path d="M2.1,16.8L1,16.2V-0.2l1.2-0.6l12.5,8.2v1.3L2.1,16.8z M2.5,1.2v13.7L12.9,8L2.5,1.2z" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Play.js